// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zHDpa","cardIcon":"Card_cardIcon__nM7qm","cardTitle":"Card_cardTitle__dsOlA","cardDescription":"Card_cardDescription__XyGsM"};